import React from "react";
import Header from "../Components/nav";
import Footer from "../Components/footer";
import Form from "../Components/form";
import ServicesPortfolio from "../Components/servicesPortfolio";
import Bottomfooter from "../Components/bottomfooter";

const ServiceRoute = () => {
  return (
    <div>
      <Header active3="active" />
      <Form apiRoute="https://business-guru-server.vercel.app/general-enquiry" />
      <ServicesPortfolio />
      <Footer />
      {/* <Bottomfooter /> */}
    </div>
  );
};

export default ServiceRoute;
